import { render, staticRenderFns } from "./ScienceRight.vue?vue&type=template&id=aa0891c6&scoped=true&"
import script from "./ScienceRight.vue?vue&type=script&lang=js&"
export * from "./ScienceRight.vue?vue&type=script&lang=js&"
import style0 from "./ScienceRight.vue?vue&type=style&index=0&id=aa0891c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0891c6",
  null
  
)

export default component.exports